import React, { useState, useEffect } from 'react'
import AccordionChild from './accordion-child'
import dompurify from 'dompurify'

const AccordionParent = ({
  title = '',
  child = { title: '', data: [] },
  number = 0,
  desc = '',
  targetScroll = ''
}) => {
  const sanitizer = dompurify.sanitize

  const [isShow, setShow] = useState(false)
  const handleClickAccordionParent = e => {
    e.preventDefault()
    var idFaq = e.currentTarget.id
    var cutFaq = idFaq.replace(/[^0-9]/g, '')
    document.getElementById(cutFaq).classList.toggle('active')
    setShow(prevState => {
      return !prevState
    })
  }

  window.onload = function () {
    if (window.location.hash !== '') {
      // Use #8 or for linking
      let findHash = window.location.hash
      let cutHash = findHash.slice(1)
      document.getElementById(cutHash).classList.add('active')
    }
  }

  return (
    <div className="list">
      <a
        // href="/"
        onClick={handleClickAccordionParent}
        className="title"
        id={targetScroll}
      >
        <div className="number">{number} </div>
        <div className="right">
          <span className="title-accordion">{title}</span>
          <div className="arrow">
            <i className={`icon-arrow ${isShow ? 'up' : 'down'}`}></i>
          </div>
        </div>
      </a>
      {child.data.length > 0 ? (
        // do not delete div under this comment for reference
        // <div id={number} className={`content-parent ${isShow ? 'active' : ''}`}>
        <div id={number} className="content-parent">
          <div className={'content'}>
            <div className="content-title">{child.title}</div>
            {child.data.map((item, key) => {
              return <AccordionChild {...item} key={key}></AccordionChild>
            })}
          </div>
        </div>
      ) : (
          <div id={number} className={`content-parent ${isShow ? 'active' : ''}`}>
            <div
              className={'content'}
              dangerouslySetInnerHTML={{ __html: sanitizer(desc) }}
            ></div>
          </div>
        )}
    </div>
  )
}

export default AccordionParent